export default __webpack_public_path__ + "static/media/sales.e02f9a5c.svg";